<template>
  <div>
    <v-alert v-if="error" type="error" class="mt-2">
      {{ error }}
    </v-alert>
    <v-autocomplete
      v-else
      v-model="selected"
      :label="label"
      :items="clients"
      :loading="loading || innerLoading"
      outlined
      :search-input.sync="search"
      :filter="customFilter"
      item-text="name"
      return-object
      :menu-props="{ maxHeight: '400' }"
      :clearable="clearable"
      :disabled="disabled"
      @focus="getClients"
      hide-details
      :dense="dense"
    >
      <template v-slot:no-data>
        <div class="pa-2 px-4">Nenhum cliente encontrado</div>
      </template>
      <template v-slot:item="{ item }">
        {{ item.name }}
        <v-chip small color="primary" label class="ml-2">
          #{{ item.accessId }}
        </v-chip>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import STORE from "@/services/store";

export default {
  name: "ClientSelect",
  emits: ["input", "change"],
  props: {
    loading: Boolean,
    disabled: Boolean,
    value: Array | Object,
    clearable: Boolean,
    label: String,
    dense: Boolean,
  },
  computed: {
    ...mapGetters("store", ["selectedStore"]),
    selected: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
        this.$emit("change", value);
      },
    },
  },
  data: () => ({
    search: "",
    clients: [],
    error: false,
    innerLoading: false,
  }),
  methods: {
    async getClients() {
      try {
        if (this.innerLoading) return;
        if (this.clients.length) return;

        this.innerLoading = true;
        this.error = false;

        const { clients } = await STORE.client.list(this.selectedStore.id);

        this.clients = clients.filter((client) => client.accessId);
      } catch (e) {
        this.error = e.message || "Erro desconhecido";
      } finally {
        this.innerLoading = false;
      }
    },
    customFilter(item, queryText, itemText) {
      const query = queryText.toString().toLowerCase();

      const { name, accessId } = item;

      return (
        name.toLowerCase().indexOf(query) > -1 ||
        accessId.toString().indexOf(query) > -1
      );
    },
  },
};
</script>
